


























import { computed, defineComponent, toRefs, PropType, watch } from '@vue/composition-api';
import { IdentityInfo, VideoRelatedType, AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from './../../../../utils/index';
import TtamAffiliateIdentity from '../../../identity/affiliate-identity-compose.vue';
const name = 'ttam-library-operation';

export default defineComponent({
  name,
  props: {
    isRelatedProduct: {
      type: Boolean,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    curIdentityInfo: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({}),
    },
    isLoading: { type: Boolean, default: false },
  },
  components: {
    TtamAffiliateIdentity,
  },
  setup(props, { emit }) {
    const { isRelatedProduct } = toRefs(props);
    const localVideoRelatedType = computed({
      get() {
        return isRelatedProduct.value ? VideoRelatedType.Related : VideoRelatedType.NotRelated;
      },
      set(val) {
        const eventName =
          val === VideoRelatedType.Related
            ? 'ad_start_with_product_related_video_click'
            : 'ad_start_with_product_other_video_click';
        trackEvent(eventName);
        emit('video-related-type-change', val === VideoRelatedType.Related);
      },
    });
    watch(
      isRelatedProduct,
      val => {
        if (val === undefined) {
          localVideoRelatedType.value = VideoRelatedType.Related;
        }
      },
      {
        immediate: true,
      },
    );
    const videoRelatedOptions = computed(() => [
      {
        label: i18n.t('module_creative_affiliate_video_title'),
        value: VideoRelatedType.Related,
        desc: i18n.t('module_creative_related_video_title_tips'),
      },
      {
        label: i18n.t('module_creative_other_video_title'),
        value: VideoRelatedType.NotRelated,
        desc: i18n.t('module_creative_other_video_title_tips'),
      },
    ]);
    const identityChangeHandler = val => {
      emit('identity-change', val);
    };
    const openAuthorizePostDrawer = () => {
      emit('open-authorize-post-drawer');
    };
    return {
      name,
      videoRelatedOptions,
      localVideoRelatedType,
      identityChangeHandler,
      openAuthorizePostDrawer,
    };
  },
});
